import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f0d5e8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contains-loader" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "is-hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "Total")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "th-wrap tw-justify-center"
}


import PerformanceBreadcrumb from "../Breadcrumb.vue";
import TableControls from "./Controls.vue";
import ExportData from "../../Pieces/ExportData.vue";
import PeekTaxonomyTwo from "./PeekTaxonomyTwo.vue";
import PerformanceField from "./PerformanceField.vue";
import { UseReportSettingsStore } from "../../State/Stores/ReportSettingsStore";
//Dynamic Components
const __default__ = {
  name: "PerformanceTable",
  components: {
    ExportData,
    PeekTaxonomyTwo,
    PerformanceBreadcrumb,
    PerformanceField,
    TableControls,
  },
};
import { UsePerformanceTable } from "./Hooks/UsePerformanceTable";
import { UseTableColumns } from "./Hooks/UseTableColumns";
import { storeToRefs } from "pinia";
import { watch, computed, toRefs, defineAsyncComponent } from "vue";
import { UseStringHelper } from "../../../Helper/Functional/UseStringHelper";
import { UseAxiosErrorHelper } from "../../../Helper/ThirdParty/UseAxiosErrorHelper";
import { UseTaxonomyHelper } from "../../../Helper/Stateful/UseTaxonomyHelper";
import { UseComparisonHelper } from "../../../Helper/Stateful/UseComparisonHelper";
import { PerformanceTableAndChartData } from "../../../Helper/Stateful/PerformanceTableAndChartData";
import { UseProgramStore } from "../../State/Stores/ProgramStore";
import { UseDateStore } from "../../State/Stores/DateStore";
import { UsePerformanceTableDetails } from "./Hooks/UsePerformanceTableDetails";
import { StaticColumnData } from "../../../StaticData/StaticColumnData";
import {
  IGeTAllTableHeaders,
  TAllTableHeaderValues,
  TComparisonDataFirstProps,
  TAllTableHeaders,
} from "../../../../typings/DataFetching";
import { IDetailTreeSingle } from "../../../../typings/TableTypes";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showTableOnly: { type: Boolean, default: false },
    tableData: null,
    detailTree: null,
    headers: null,
    comparisonData: null,
    taxonomy: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { showTableOnly: boolean, tableData: TAllTableHeaderValues<IGeTAllTableHeaders>[], detailTree: IDetailTreeSingle, headers: TAllTableHeaders, comparisonData: TComparisonDataFirstProps, taxonomy: string, loading: boolean }

UseAxiosErrorHelper();

const {
  getPerformanceTableSortMetric: sortField,
  getPerformanceTableSortDirection: sortOrder,
} = storeToRefs(UseReportSettingsStore());
const { getCurrentProgramName } = storeToRefs(UseProgramStore());
const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());



const {
  tableData: data,
  comparisonData,
  detailTree,
  headers,
  taxonomy,
  loading,
  showTableOnly,
} = toRefs(props);

const {
  fetchNavigationUrl,
  columns,
  perPage,
  page,
  chunkedDataHook,
  pageDataHook,
  sortedDataHook,
  isColumnVisible,
  onSort,
  fetchComparisonMetric,
} = UsePerformanceTable();
const { detailOpenedFinal, detailClosedFinal } = UsePerformanceTableDetails();
const { clearComparisonData } = PerformanceTableAndChartData();

const { comparing, init } = UseComparisonHelper();

const { validateInternalParameter } = UseStringHelper();

const { columnSkeleton, footerSkeleton } = UseTableColumns();

const footerValues = footerSkeleton(data, comparisonData);

const { availableColumns } = StaticColumnData();

const exportData = computed(() => {
  return data.value?.map((d) => ({
    ...d,
    first_click_conversion_rate: +d.first_click_conversion_rate / 100,
    last_click_conversion_rate: +d.last_click_conversion_rate / 100,
    attributed_conversion_rate: +d.attributed_conversion_rate / 100,
    attributed_revenue_variance_percent: +d.attributed_revenue_variance_percent / 100,
  }));
});

const exportComparisonData = computed(() => {
  return Object.values(comparisonData.value)?.map((d) => ({
    ...d,
    first_click_conversion_rate: +d.first_click_conversion_rate / 100,
    last_click_conversion_rate: +d.last_click_conversion_rate / 100,
    attributed_conversion_rate: +d.attributed_conversion_rate / 100,
    attributed_revenue_variance_percent: +d.attributed_revenue_variance_percent / 100,
  }));
});

const {
  taxonomyOne,
  taxonomyTwo,
  taxonomyThree,
  taxonomyFour,
  currentTaxonomyInteger,
} = UseTaxonomyHelper();

const components = [
  defineAsyncComponent(() => import("./PeekTaxonomyTwo.vue")),
  defineAsyncComponent(() => import("./PeekTaxonomyThree.vue")),
  defineAsyncComponent(() => import("./PeekTaxonomyFour.vue")),
];

const taxonomyLabel = computed(() => {
  return currentTaxonomyInteger.value < 5
    ? currentTaxonomyInteger.value
    : currentTaxonomyInteger.value - 1;
});

const taxonomyArray = computed(() => {
  const array: string[] = [];
  for (let n = 1; n <= currentTaxonomyInteger.value; n++) {
    array.push(`taxonomy_${n}`)
  }
  return array
})

//Methods
const sortedData = sortedDataHook(data, sortField, sortOrder);

const chunkedData = chunkedDataHook(sortedData, perPage);

const pageData = pageDataHook(chunkedData, data, page);
//These two need the row emitted by the v-on handler on the table that is yet to be typed at a library level
const detailOpened = (row: TAllTableHeaders) => {
  detailOpenedFinal(row)(taxonomy.value, detailTree);
};

const detailClosed = (row: TAllTableHeaders) =>
  detailClosedFinal(row)(taxonomy.value, detailTree);

watch(comparing, () => {
  if (!comparing.value) {
    init();
    clearComparisonData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_loading = _resolveComponent("o-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(showTableOnly))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(PerformanceBreadcrumb, {
            "taxonomy-one": _unref(taxonomyOne),
            "taxonomy-two": _unref(taxonomyTwo),
            "taxonomy-three": _unref(taxonomyThree),
            "taxonomy-four": _unref(taxonomyFour)
          }, null, 8, ["taxonomy-one", "taxonomy-two", "taxonomy-three", "taxonomy-four"]),
          _createVNode(TableControls, null, {
            export: _withCtx(() => [
              _createVNode(ExportData, {
                "comparison-data": _unref(exportComparisonData),
                "show-comparison": _unref(comparing),
                "available-columns": _unref(taxonomyArray).concat(_unref(availableColumns)),
                "selected-columns": _unref(taxonomyArray).concat(_unref(columns)),
                "column-headers": _unref(headers),
                "report-name": 
              (_unref(getCurrentProgramName) + '_performance_' + _unref(getDateFrom) + '_' + _unref(getDateTo))
                .toLowerCase()
                .split(' ')
                .join('_')
            ,
                "exportable-data": _unref(exportData),
                "order-data-by": _unref(sortField),
                "order-data-direction": _unref(sortOrder)
              }, null, 8, ["comparison-data", "show-comparison", "available-columns", "selected-columns", "column-headers", "report-name", "exportable-data", "order-data-by", "order-data-direction"])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    (_unref(data).length)
      ? (_openBlock(), _createBlock(_component_o_table, {
          key: 1,
          class: "has-sticky-table-headers",
          ref: "performanceTableTaxonomyOne",
          narrowed: "",
          hoverable: "",
          data: _unref(pageData),
          detailed: "",
          "custom-row-key": _unref(taxonomy),
          customDetailRow: "",
          "show-detail-icon": _unref(currentTaxonomyInteger) < 5,
          onDetailsOpen: detailOpened,
          onDetailsClosed: detailClosed,
          "default-sort-direction": _unref(sortOrder),
          "onUpdate:default-sort-direction": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sortOrder) ? (sortOrder).value = $event : null)),
          "default-sort": [_unref(sortField), _unref(sortOrder)],
          onSort: _unref(onSort)
        }, _createSlots({
          detail: _withCtx((props) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(components[_unref(currentTaxonomyInteger) - 1]), {
              "top-taxonomy": _unref(currentTaxonomyInteger),
              index: props.index,
              row: props.row,
              tree: _unref(detailTree)[props.row[_unref(taxonomy)]].data,
              "onUpdate:tree": ($event: any) => ((_unref(detailTree)[props.row[_unref(taxonomy)]].data) = $event)
            }, null, 8, ["top-taxonomy", "index", "row", "tree", "onUpdate:tree"]))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_o_table_column, {
              field: _unref(taxonomy),
              label: `Taxonomy ${_unref(taxonomyLabel)}`,
              sortable: ""
            }, {
              default: _withCtx((props) => [
                (_unref(currentTaxonomyInteger) < 5 && props.row[_unref(taxonomy)] !== 'None')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `${_unref(fetchNavigationUrl)}${_unref(validateInternalParameter)(props.row[_unref(taxonomy)])}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row[_unref(taxonomy)]), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.row[_unref(taxonomy)]), 1))
              ]),
              _: 1
            }, 8, ["field", "label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnSkeleton), (col, i) => {
              return (_openBlock(), _createBlock(_component_o_table_column, {
                key: i,
                field: col.field,
                label: _unref(headers) ? _unref(headers)[col.field] : col.label,
                sortable: true,
                visible: _unref(isColumnVisible)(col.field),
                position: "centered"
              }, {
                default: _withCtx((props) => [
                  _createVNode(PerformanceField, {
                    current: props.row[col.field],
                    previous: _unref(fetchComparisonMetric)(props.row[_unref(taxonomy)], col.field),
                    monetary: col.monetary,
                    rounded: col.rounded,
                    percentage: col.percentage,
                    "one-decimal": col.oneDecimal,
                    opposite: col.opposite,
                    comparing: _unref(comparing)
                  }, null, 8, ["current", "previous", "monetary", "rounded", "percentage", "one-decimal", "opposite", "comparing"])
                ]),
                _: 2
              }, 1032, ["field", "label", "visible"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_unref(data).length && !_unref(loading))
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerValues), (foot, i) => {
                    return (_openBlock(), _createElementBlock("th", {
                      class: _normalizeClass(["is-hidden-mobile", { 'hide-cell': !_unref(isColumnVisible)(foot.field) }]),
                      key: i
                    }, [
                      (foot.fallback)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", null, _toDisplayString(foot.fallback), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!foot.fallback?.length)
                        ? (_openBlock(), _createBlock(PerformanceField, {
                            key: 1,
                            current: foot.current,
                            previous: foot.previous,
                            monetary: foot.monetary,
                            rounded: foot.rounded,
                            percentage: foot.percentage,
                            "one-decimal": foot.oneDecimal,
                            opposite: foot.opposite,
                            comparing: _unref(comparing),
                            footer: ""
                          }, null, 8, ["current", "previous", "monetary", "rounded", "percentage", "one-decimal", "opposite", "comparing"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              }
            : undefined
        ]), 1032, ["data", "custom-row-key", "show-detail-icon", "default-sort-direction", "default-sort", "onSort"]))
      : _createCommentVNode("", true),
    _createVNode(_component_o_loading, {
      "full-page": false,
      active: _unref(loading),
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null))
    }, null, 8, ["active"])
  ]))
}
}

})